// removed by extract-text-webpack-plugin
module.exports = {"narrowMax":"1000","wideMax":"Infinity","narrow":"narrow","wide":"wide"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/app_secchi_std.scss
// module id = z1af
// module chunks = 6